import React from 'react'
import styled from 'styled-components'

const Badge = styled.span`
  font-size: .8rem!important;
  .mb {
    margin-bottom: 1px;
  }
  .mt {
    margin-top: 1px;
  }
`;

export default function SelectorBadge(props) {
    const {
        inputName,
        inputValue,
        icon = null,
        text,
        handleRemove,
        bgColor = 'gc-light-blue-dark'
    } = props;

    return (
        <Badge className={"badge text-gc-dark-blue d-inline-flex align-items-center badge-" + bgColor}>
            { icon && (
                <span className="mb">{icon}</span>
            )}
            <span className="mb">
                {text}
            </span>
            <i className="fas fa-times cursor-pointer ml-1 mt" onClick={() => handleRemove(inputValue)}></i>
            <input type="hidden" name={inputName} value={inputValue} />
        </Badge>
    );
}